{
  "badRequestMessage": "An unexpected error occurred",
  "incorrectlyFilledFields": "The entered data is incorrect. Incorrect fields have been highlighted.",
  "authErrorMessage": "Incorrect authentication",
  "formHasWarnings": "Warnings have appeared in the entered data. Messages have been listed next to the relevant fields.",
  "operationNotSupported": "The operation is not supported."
}
